import { z } from 'zod'

const ItemSchema = z.object({
  id: z.number(),
  seq: z.number(),
  itemId: z.number(),
  lotNo: z.string(),
  qty: z.number(),
})

export const Sale2310GetResultSchema = z.object({
  number: z.string(),
  date: z.string(),
  partyId: z.number(),
  refNo: z.string(),
  refDate: z.string(),
  reasonCode: z.string().nullish(),
  remark: z.string().nullish(),
  items: z.array(ItemSchema),
  status: z.number(),
  warehouseDocumentId: z.number().nullable().optional(),
  receivedCompleted: z.boolean(),
})

export type Sale2310GetResultModel = z.input<typeof Sale2310GetResultSchema>
